export async function sendCode(url: RequestInfo, token: string, id: number, tipo_id: string) {

    return await fetch(url + '/api/send-code', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'token': token,
                'id': id,
                'tipo_id': tipo_id,
            }
        )
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });
}